import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import router from '@/router/index.js' // 如果你有路由文件，取消注释用于跳转登录页

// 1. 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '//www.aboluo.site/api', // 基础地址，可从环境变量读取
  timeout: 15000, // 请求超时时间 (15秒)
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// ==========================================
// 2. 请求拦截器 (Request Interceptor)
// ==========================================
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么

    // 从 localStorage 获取 token ( key 名需与你登录时保存的一致，例如 'user_token' )
    let currentRouteName = router.currentRoute.value ? router.currentRoute.value.name : router.currentRoute.name;
    let token = "";
    if (currentRouteName === 'ShuaituMorPPage') {
      token = localStorage.getItem('auth_token');
    } else {
      token = localStorage.getItem('token');
    }

    if (token) {
      // 让每个请求都携带自定义 token
      // 格式必须与后端 login_required 解析逻辑一致： "Bearer <token>"
      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求发生错误:', error)
    return Promise.reject(error)
  }
)

// ==========================================
// 3. 响应拦截器 (Response Interceptor)
// ==========================================
service.interceptors.response.use(
  /**
   * 如果响应状态码是 2xx (如 200)，直接进入这里
   */
  response => {
    const res = response.data

    // 注意：后端可能返回 200 OK，但业务逻辑上是失败的 (success: false)
    // 这里可以根据你的后端规范统一处理

    // 如果你的后端约定：只有 success: true 才是真的成功
    if (res.success === false && res.po === false) {
      // 业务错误提示
      ElMessage({
        message: res.message || '操作失败',
        type: 'error',
        duration: 3000
      })

      // 特殊错误码处理 (示例)
      // 如果后端返回特定错误码表示 Token 过期，可在此处强制登出
      // if (res.code === 40100) {
      //   handleLogout()
      // }

      // 返回一个 rejected 的 Promise，让调用处的 catch 也能捕获到业务错误
      return Promise.reject(new Error(res.message || 'Error'))
    }

    // 如果成功，直接返回数据部分 (方便组件里直接用 res.data)
    // 如果你想保留整个 response 对象，可以直接 return response
    return res
  },

  /**
   * 如果响应状态码不是 2xx (如 401, 403, 500)，进入这里
   */
  error => {
    console.error('请求错误:', error)

    let message = '网络异常，请稍后重试'

    if (error.response) {
      const status = error.response.status
      const data = error.response.data

      switch (status) {
        case 400:
          message = data?.message || '请求参数错误'
          break
        case 401:
          message = '登录已过期或身份无效，请重新登录'
          // 【关键】Token 失效处理
          handleLogout()
          break
        case 403:
          message = data?.message || '拒绝访问 (无权限)'
          break
        case 404:
          message = '请求的资源不存在'
          break
        case 500:
          message = data?.message || '服务器内部错误'
          break
        case 429:
          message = data?.message || '请求过于频繁，请1分钟后再试'
          break
        default:
          message = data?.message || `连接错误 ${status}`
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应 (超时或网络断开)
      message = '服务器无响应，请检查网络连接'
    }

    // 统一弹出错误提示
    ElMessage({
      message: message,
      type: 'error',
      duration: 3000
    })

    return Promise.reject(error)
  }
)

// ==========================================
// 4. 辅助函数：退出登录
// ==========================================
function handleLogout() {
  // 清除本地存储的 token
  let current_address = localStorage.getItem('current_address');
  localStorage.removeItem('current_address');
  localStorage.removeItem('auth_token');
  // 清除用户信息 (如果有)
  localStorage.removeItem('userData');
  localStorage.removeItem('token');
  localStorage.removeItem('user_info');

  // 提示用户
  ElMessageBox.confirm('登录状态已失效，您可以取消留在该页面，或者重新登录', '确认登出', {
    confirmButtonText: '重新登录',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    // 跳转到登录页 (需根据你的路由路径调整)
    // window.location.href = '/login' 
    // 或者如果使用 vue-router:
    // router.push('/login')
    if (current_address == 'ShuaituMorPPage') {
      window.location.reload();
    } else {
      router.push({ name: 'LoginPage' });
    }
  }).catch((e) => {
    // 用户点击取消
    console.log(e);
  })
}

// 导出实例
export default service